export enum SortDirections {
  asc = 'asc',
  desc = 'desc',
}
